import { gql } from '@apollo/client';
import CLINIC_TICKET_FRAGMENT from '../fragments/clinicTicketFragment';

const CLINIC_TICKET_QUERY = gql`
  query clinicTicket($id: ID!) {
    clinicTicket(id: $id) {
      ...ClinicTicketFragment
    }
  }

  ${CLINIC_TICKET_FRAGMENT}
`;

export default CLINIC_TICKET_QUERY;
